import React from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';

import SweetAlert from 'react-bootstrap-sweetalert';
import styles from './ModalSweet.css';

const IPropTypes = {
  isOpen: PropTypes.bool,
  children: PropTypes.any,
  title: PropTypes.string,
  confirmBtnText: PropTypes.string,
  cancelBtnText: PropTypes.string,
  showCancel: PropTypes.bool,
  confirmCallback: PropTypes.func,
  cancelCallback: PropTypes.func,
};

const defaultProps = {
  isOpen: false,
  children: '',
  title: 'Title',
  confirmBtnText: 'Aceptar',
  cancelBtnText: 'Cancelar',
  showCancel: false,
  confirmCallback: () => null,
  cancelCallback: () => null,
};

class ModalSweet extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    if (!this.props.isOpen) {
      return null;
    }

    return (
      <SweetAlert
        title={this.props.title}
        showCancel={this.props.showCancel}
        confirmBtnText={this.props.confirmBtnText}
        confirmBtnCssClass={`${styles.btnAccept} ${styles.btn}`}
        cancelBtnText={this.props.cancelBtnText}
        cancelBtnCssClass={`${styles.btnNoAccept} ${styles.btn}`}
        onConfirm={this.props.confirmCallback}
        onCancel={this.props.cancelCallback}
        closeOnClickOutside={false}
        style={{
          width: '100%',
          left: 0,
          right: 0,
          maxWidth: '500px',
          margin: '0 auto',
          top: '30%',
        }}
      >
        {this.props.children}
      </SweetAlert>
    );
  }
}

ModalSweet.propTypes = IPropTypes;
ModalSweet.defaultProps = defaultProps;

const ObservedModalSweet = observer(ModalSweet);

export { ObservedModalSweet as ModalSweet };



// WEBPACK FOOTER //
// ./src/common/modal-sweet/ModalSweet.jsx